import { BasicFrameConfig } from 'InternalLibrary';
import { DesktopFooter } from 'components/molecules/DesktopFooter/DesktopFooter';
import { isInWebView } from '../../../utils/isInWebView';
import { MobileFooter } from 'components/molecules/MobileFooter/MobileFooter';
import { SimpleNavbar } from 'components/molecules/SimpleNavbar/SimpleNavbar';
import { useEffect } from 'react';
import classNames from 'classnames';
import React from 'react';
import styles from './BasicFrame.module.scss';
import VersionInfo from 'components/atoms/VersionInfo/VersionInfo';

export interface BasicFrameProps extends BasicFrameConfig {
  backBtnHidden?: boolean;
  children: React.ReactNode;
  pageTitle?: string;
  className?: string;
  contentWrapperClassName?: string;
  contentLayoutClassName?: string;
  logoLeft?: boolean;
  hideBack?: boolean;
}

export const BasicFrame: React.FC<BasicFrameProps> = (props) => {
  const {
    pageTitle,
    children,
    className,
    hideLogout,
    onLogoutButtonClick,
    headerLayout,
    footerLayout,
  } = props;

  useEffect(() => {
    if (pageTitle !== undefined) {
      document.title = pageTitle;
    }
  }, [pageTitle]);

  return (
    <div className={classNames(styles['wrapper'], className)} data-test="frame">
      <VersionInfo />
      <div className={classNames(styles['body'])} data-test="frame-body">
        {/* Header */}
        <SimpleNavbar
          {...props}
          hideLogout={hideLogout}
          onLogoutButtonClick={onLogoutButtonClick}
          headerLayout={headerLayout}
        />

        {/* Content Layout */}
        <div
          className={classNames(
            styles['content-layout'],
            footerLayout === 'centered' && styles['footer-centered'],
            props.contentLayoutClassName,
          )}
          data-test="frame-layout"
        >
          {/* Content Wrapper */}
          <div
            className={classNames(
              styles['content-wrapper'],
              headerLayout === 'centered' && styles['header-centered'],
              footerLayout === 'default' && styles['footer-default'],
              props.contentWrapperClassName,
            )}
            data-test="frame-content"
          >
            {children}
          </div>
        </div>
        {/* Footers */}
        <DesktopFooter
          className={styles['desktop-footer']}
          content={props.frameContent}
          layout={footerLayout}
          showTermsConditions
        />
        {!props.hideMobileFooter && !isInWebView() && (
          <MobileFooter
            content={props.frameContent}
            hideLogout={hideLogout}
            onLogoutButtonClick={onLogoutButtonClick}
          />
        )}
      </div>
    </div>
  );
};
